// Shared "Save As…" helper for read results (flash + EEPROM dumps).
// Same folder-pick UX as the Map Editor: Android native SAF folder picker →
// desktop/web File System Access API → plain download fallback. Works inside
// the Android app, the Windows EXE (WebView2/Chromium) and any browser.

export async function bytesToDataUrl(bytes) {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => resolve(fr.result);
    fr.onerror = reject;
    fr.readAsDataURL(new Blob([bytes], { type: 'application/octet-stream' }));
  });
}

// Returns true if the file was saved/queued, false if the user cancelled.
export async function saveBinaryWithPicker(bytes, name, { onLog, toast } = {}) {
  // 1) Android native app — pick a folder via Storage Access Framework.
  if (window.AndroidDownloader && typeof window.AndroidDownloader.saveWithPicker === 'function') {
    try {
      const dataUrl = await bytesToDataUrl(bytes);
      window.AndroidDownloader.saveWithPicker(dataUrl, name);
      toast?.success?.('Pilih folder untuk menyimpan…', { id: 'saveas', description: name });
      onLog?.('SUCCESS', `Save As → pilih folder di Android: ${name}`);
      return true;
    } catch (e) { /* fall through */ }
  }
  // 2) Desktop EXE / modern browser — folder + name picker.
  if (window.showSaveFilePicker) {
    try {
      const ext = (name.match(/\.[A-Za-z0-9]+$/) || ['.bin'])[0].toLowerCase();
      const handle = await window.showSaveFilePicker({
        suggestedName: name,
        types: [{ description: `File ${ext}`, accept: { 'application/octet-stream': [ext] } }],
      });
      const w = await handle.createWritable();
      await w.write(bytes);
      await w.close();
      toast?.success?.(`Tersimpan ke ${handle.name}`, { id: 'saveas' });
      onLog?.('SUCCESS', `Save As → ${handle.name}`);
      return true;
    } catch (e) {
      if (e && e.name === 'AbortError') { onLog?.('INFO', 'Save As dibatalkan.'); return false; }
      // any other error → fall back to download
    }
  }
  // 3) Fallback — plain download to the default folder.
  const url = URL.createObjectURL(new Blob([bytes], { type: 'application/octet-stream' }));
  const a = document.createElement('a');
  a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
  onLog?.('SUCCESS', `Tersimpan (download): ${name}`);
  return true;
}
